import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { getDocumentMeta } from "utils/getDocumentMeta";

const schedulerRoutePattern = /^\/appointments\/[^/]+(?:\/.*)?$/;
const knownPatientRoutePattern =
  /^\/appointments\/[^/]+\/start\/?$/;
const alwaysV3RoutePatterns = [ /^\/my-account\/home(?:\/.*)?$/,
                                /^\/order_status(?:\/.*)?$/,
                                /^\/my-account\/communication-preferences(?:\/.*)?$/,
                                /^\/successNew(?:\/.*)?$/,
                                /^\/no-patient(?:\/.*)?$/,
                                knownPatientRoutePattern,
                              ];
const excludedV3RoutePatterns = [
                                  /^\/my-account\/check-in(?:\/.*)?$/,
                                ];

export const useSchedulingABVariant = () => {
  const history = useHistory();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const isKnownPatientRoute =
    knownPatientRoutePattern.test(location.pathname) &&
    params.get("kp") === "1";
  const isSchedulerRoute =
    schedulerRoutePattern.test(location.pathname) &&
    !isKnownPatientRoute;
  
  const isAlwaysV3Route = alwaysV3RoutePatterns.some((pattern) => pattern.test(location.pathname));
  const isExcludedV3Route = excludedV3RoutePatterns.some((pattern) => pattern.test(location.pathname));
  const isSchedulerV3GlobalEnabled = getDocumentMeta("scheduler_v3_default_global") === "true";

  const isV3 =
    !isExcludedV3Route &&
    (
      isAlwaysV3Route ||
      isKnownPatientRoute ||
      params.has("V3") ||
      getDocumentMeta("new_scheduler_design") === "true"
    );

  React.useEffect(() => {
    if (!isSchedulerRoute) {
      return;
    }

    if (isSchedulerV3GlobalEnabled) return;
  }, [isSchedulerRoute, isSchedulerV3GlobalEnabled]);
  return { isV3 };
};
